import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  stopDetailsContainer: {
    marginTop: 12,
  },
  stopHeaderContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  stopName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  stopAddress: {
    color: theme.subHeaderTextColor,
    fontSize: theme.textFontSize,
    fontWeight: 400,
  },
});

const StopDetailsTitle = ({ classes, stopName, stopAddress, driverNumber }) => (
  <div className={classes.stopDetailsContainer}>
    <div className={classes.stopHeaderContainer}>
      <span className={classes.stopName}>{stopName}</span>
      <span className={classes.stopName}>#{driverNumber}</span>
    </div>
    <div>
      <span className={classes.stopAddress}>{stopAddress}</span>
    </div>
  </div>
);

export default withStyles(styles)(StopDetailsTitle);
